<template>
  <div class="page-form">
    <!-- <pre>{{passes}}</pre> -->
    <div id="cart_content_div" class="table-responsive">
      <table id="cart_contents" class="table table-small">
        <thead>
          <tr>
            <th v-if="showAppleWalletUrl"></th>
            <th>Pass/Permit Type</th>
            <th v-if="showPassID">Pass/Permit ID</th>
            <th>Start Date</th>
            <th>Valid Through</th>
            <th v-if="showVehicle">Vehicle Type</th>
            <th v-if="showVehicle">License Plate</th>
            <th v-if="showAttendeeInfo">Adults</th>
            <th v-if="showAttendeeInfo">Children</th>
            <th v-if="showDaysNights">Days</th>
            <th v-if="showDaysNights">Nights</th>
            <th>Pass/Permit Holder</th>
            <th>Visitor Email</th>
            <th style="text-align: right">Price</th>
            <th v-if="showPassDownloadUrl"></th>
            <th>
              <span class="sr-only">Remove</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="pass in passes" :key="pass.id">
            <td v-if="showAppleWalletUrl">
              <a :href="pass.appleWalletUrl">
                <img
                  src="https://support.apple.com/library/content/dam/edam/applecare/images/en_US/iOS/add-to-apple-wallet-logo.png"
                  alt="Tap here on an iPhone or iPod touch to download your pass or permit to Apple Wallet"
                  width="120"
                  height="37"
                />
              </a>
            </td>
            <td>{{ pass.description }}</td>
            <td v-if="showPassID">{{ pass.passid }}</td>
            <td>{{ pass["start-date"] | formatDate }}</td>
            <td>{{ pass.enddate | formatDate }}</td>
            <td v-if="showVehicle">{{ pass.vehicleDisplayValue }}</td>
            <td v-if="showVehicle">{{ pass.licenseplate }}</td>
            <td v-if="showAttendeeInfo">{{ pass.adults }}</td>
            <td v-if="showAttendeeInfo">{{ pass.children }}</td>
            <td v-if="showDaysNights">{{ passDays(pass) }}</td>
            <td v-if="showDaysNights">{{ passNights(pass) }}</td>
            <td>{{ pass.firstname }} {{ pass.lastname }}</td>
            <td>{{ pass.visitoremail }}</td>
            <td style="text-align:right">
              {{ (pass.priceDetails.price / 100000) | formatCurrency }}
            </td>
            <td
              valign="middle"
              v-if="pass.passUrl != '' && showPassDownloadUrl"
            >
              <a :href="pass.passUrl" class="btn btn-primary btn-sm">
                View Pass/Permit
                <span class="glyphicon glyphicon-chevron-right"></span>
              </a>
            </td>

            <td>
              <button
                type="button"
                class="btn btn-light btn-sm cart-delete-button"
                title="Remove"
                @click="removePass(pass.id)"
                v-if="allowPassRemoval === 'true'"
              >
                <font-awesome-icon icon="times" aria-hidden="true" />
                <span class="sr-only">Remove item</span>
              </button>
            </td>
          </tr>
          <tr v-if="passes.length === 0">
            <td :colspan="priceColspan">
              There are no items currently in the cart.
            </td>
          </tr>
          <tr>
            <td :colspan="priceColspan" class="text-right">
              <span v-if="feeTotal > 0">
                *Administrative Fee:
                <br />
              </span>
              <b>Total Price:</b>
            </td>
            <td class="text-right">
              <span v-if="feeTotal > 0">
                {{ feeTotal | formatCurrency }}
                <br />
              </span>
              <b>{{ totalPrice | formatCurrency }}</b>
            </td>
            <td></td>
          </tr>
        </tbody>
        <tfoot v-if="feeTotal > 0">
          <tr>
            <td :colspan="priceColspan + 1">
              <p>
                *Please Note: This online service is provided by a third party
                working in partnership with the {{ agencyName }}. No portion of
                the reservation fee charged by the third party is provided to
                the {{ agencyName }}.
              </p>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faTimes);

export default {
  name: "PassList",
  components: {
    FontAwesomeIcon
  },
  props: ["allowPassRemoval", "agencyName"],
  computed: {
    ...mapGetters("cart", {
      passes: "passes",
      totalPrice: "totalPrice"
    }),
    showVehicle() {
      let hasVehicle = false;
      this.passes.forEach(pass => {
        if (pass["vehicle"]) {
          hasVehicle = true;
        }
      });
      return hasVehicle;
    },
    showAttendeeInfo() {
      let hasAttendees = false;
      this.passes.forEach(pass => {
        if (pass["adults"]) {
          hasAttendees = true;
        }
      });
      return hasAttendees;
    },
    showDaysNights() {
      let hasdaysnights = false;
      this.passes.forEach(pass => {
        if (pass["days"] || pass["nights"]) {
          hasdaysnights = true;
        }
      });
      return hasdaysnights;
    },
    showAppleWalletUrl() {
      let hasapplewallet = false;
      this.passes.forEach(pass => {
        if (pass["appleWalletUrl"]) {
          hasapplewallet = true;
        }
      });
      return hasapplewallet;
    },
    showPassID() {
      let haspassid = false;
      this.passes.forEach(pass => {
        if (pass["passid"]) {
          haspassid = true;
        }
      });
      return haspassid;
    },
    showPassDownloadUrl() {
      if (this.passes.length <= 1) {
        return false;
      }

      let hasdownloadurl = false;
      this.passes.forEach(pass => {
        if (pass["passUrl"]) {
          hasdownloadurl = true;
        }
      });
      return hasdownloadurl;
    },
    feeTotal() {
      let feetotal = 0.0;
      this.passes.forEach(pass => {
        if (pass.priceDetails && parseFloat(pass.priceDetails.fees) > 0) {
          feetotal += pass.priceDetails.fees / 100000;
        }
      });
      return feetotal;
    },
    priceColspan() {
      let cols = 5;
      if (this.showVehicle) {
        cols += 2;
      }
      if (this.showAttendeeInfo) {
        cols += 2;
      }
      if (this.showAppleWalletUrl) {
        cols++;
      }
      if (this.showPassID) {
        cols++;
      }
      if (this.showDaysNights) {
        cols += 2;
      }
      return cols;
    }
  },
  methods: {
    ...mapMutations("cart", ["removePassFromCart"]),
    removePass(id) {
      this.removePassFromCart(id);
    },
    passDays(pass) {
      if (!pass["days"]) {
        return "";
      }
      return pass["days"].length;
    },
    passNights(pass) {
      if (!pass["nights"]) {
        return "";
      }
      return pass["nights"].length;
    }
  }
};
</script>
